import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CashbookViewColumnViewModelStates } from '../states';
import { columnViewModelFeatureKey } from '../reducers/root';
export const ViewModelSelector = createFeatureSelector<CashbookViewColumnViewModelStates>(columnViewModelFeatureKey);
export const selectGenericDocCashbookListing_State = createSelector(
  ViewModelSelector, 
 (state: CashbookViewColumnViewModelStates) => state.column1ViewModel.genericDocCashbookListingState
);